// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"53":"2a4ed4aff514c2d2c904","246":"77aedd41ff948d3d96ca","832":"24c757284886ca0f425e","940":"054bccfd94dfc8554c0a"}[chunkId] + ".js";
};